module.exports = __webpack_public_path__ + "img/4.924c9d75.png";